<template>
  <v-app style="background-color: #f8f9fb">
    <v-container style="background-color: #eee" fluid tag="section">
      <v-alert
        v-if="mensagem"
        :type="tipoMensagem"
        dense
        text
        class="mb-4"
        dismissible
        @input="mensagem = ''"
      >
        {{ mensagem }}
      </v-alert>

      <v-row v-if="podeCadastrar">
        <v-col cols="12">
          <base-material-card
            icon="mdi-tag-plus"
            title="Nova etiqueta"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form" v-model="formValido" lazy-validation class="pt-4 pb-2">
              <v-row align="end">
                <v-col cols="12" sm="6" md="4">
                  <span>Nome</span>
                  <v-text-field
                    v-model="form.nome"
                    label="Nome da etiqueta"
                    dense
                    solo-inverted
                    :disabled="salvando"
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <span>Origem</span>
                  <v-combobox
                    v-model="form.origem"
                    :items="origensSugeridas"
                    label="Ex.: Interesse"
                    dense
                    solo-inverted
                    :disabled="salvando"
                    :rules="[obrigatorio]"
                  ></v-combobox>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <span>Ativa</span>
                  <v-switch
                    v-model="form.ativa"
                    class="mt-0"
                    :disabled="salvando"
                    inset
                    label=""
                  ></v-switch>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <span>&nbsp;</span>
                  <v-btn
                    color="#4682B4"
                    block
                    height="40"
                    style="font-size: 14px; font-weight: bold"
                    :loading="salvando"
                    :disabled="!formValido"
                    @click="cadastrar"
                  >
                    Cadastrar
                    <v-icon right dark>mdi-content-save</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </base-material-card>
        </v-col>
      </v-row>

      <v-row v-if="podeConsultar">
        <v-col cols="12">
          <base-material-card
            icon="mdi-tag-multiple"
            title="Etiquetas cadastradas"
            color="rgb(71 130 180)"
            style="margin-top: 10px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <div class="d-flex justify-end pt-4 pb-2">
              <v-btn
                color="#4682B4"
                outlined
                small
                :loading="carregando"
                @click="carregarEtiquetas"
              >
                Atualizar
                <v-icon right small>mdi-refresh</v-icon>
              </v-btn>
            </div>

            <v-data-table
              :headers="headers"
              :items="etiquetas"
              :loading="carregando"
              :items-per-page="15"
              class="elevation-0 mb-4"
              no-data-text="Nenhuma etiqueta cadastrada."
              loading-text="Carregando etiquetas..."
            >
              <template v-slot:item.ativa="{ item }">
                <v-chip
                  small
                  :color="item.ativa ? 'green' : 'grey'"
                  text-color="white"
                >
                  {{ item.ativa ? 'Sim' : 'Não' }}
                </v-chip>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>

      <v-row v-if="!podeConsultar && !podeCadastrar">
        <v-col cols="12">
          <v-alert type="warning" dense text>
            Você não possui permissão para acessar esta tela.
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import EtiquetaService from '../../services/etiqueta'

const ORIGENS_SUGERIDAS = ['Interesse', 'Comportamento', 'Status',  'Origem',  'Perfil']

export default {
  name: 'SacEtiquetas',

  data() {
    return {
      formValido: false,
      salvando: false,
      carregando: false,
      mensagem: '',
      tipoMensagem: 'info',
      etiquetas: [],
      origensSugeridas: ORIGENS_SUGERIDAS,
      form: {
        nome: '',
        origem: '',
        ativa: true,
      },
      headers: [
        { text: 'ID', value: 'id', width: '80px' },
        { text: 'Nome', value: 'nome' },
        { text: 'Origem', value: 'origem', width: '160px' },
        { text: 'Ativa', value: 'ativa', width: '100px' },
        { text: 'Criada em', value: 'dataCriacao', width: '180px' },
      ],
    }
  },

  computed: {
    user() {
      return this.$store.state.auth.user || {}
    },
    roles() {
      return Array.isArray(this.user.roles) ? this.user.roles : []
    },
    podeConsultar() {
      return (
        this.roles.includes('ROLE_ADMIN') ||
        this.roles.includes('ROLE_ETIQUETA_CONSULTA')
      )
    },
    podeCadastrar() {
      return (
        this.roles.includes('ROLE_ADMIN') ||
        this.roles.includes('ROLE_ETIQUETA_CADASTRO')
      )
    },
  },

  mounted() {
    if (this.podeConsultar) {
      this.carregarEtiquetas()
    }
  },

  methods: {
    obrigatorio(value) {
      return (value !== null && value !== undefined && String(value).trim() !== '') ||
        'Este campo é obrigatório'
    },

    extrairMensagemErro(error) {
      const data = error?.response?.data
      if (!data) return 'Não foi possível concluir a operação. Tente novamente.'
      if (typeof data === 'string') return data
      return (
        data.mensagem ||
        data.message ||
        data.mensagemErro ||
        'Não foi possível concluir a operação. Tente novamente.'
      )
    },

    limparFormulario() {
      this.form = {
        nome: '',
        origem: '',
        ativa: true,
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },

    async carregarEtiquetas() {
      if (!this.podeConsultar) {
        this.mensagem = 'Você não possui permissão para consultar etiquetas.'
        this.tipoMensagem = 'warning'
        return
      }

      this.carregando = true
      try {
        const response = await EtiquetaService.listar()
        this.etiquetas = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.error('Erro ao listar etiquetas:', error)
        this.mensagem = this.extrairMensagemErro(error)
        this.tipoMensagem = 'error'
        this.etiquetas = []
      } finally {
        this.carregando = false
      }
    },

    async cadastrar() {
      if (!this.podeCadastrar) {
        this.mensagem = 'Você não possui permissão para cadastrar etiquetas.'
        this.tipoMensagem = 'warning'
        return
      }

      if (!this.$refs.form || !this.$refs.form.validate()) return

      this.salvando = true
      this.mensagem = ''

      try {
        const payload = {
          nome: String(this.form.nome).trim(),
          origem: String(this.form.origem).trim(),
          ativa: this.form.ativa,
        }

        await EtiquetaService.cadastrar(payload)
        this.mensagem = 'Etiqueta cadastrada com sucesso.'
        this.tipoMensagem = 'success'
        this.limparFormulario()

        if (this.podeConsultar) {
          await this.carregarEtiquetas()
        }
      } catch (error) {
        console.error('Erro ao cadastrar etiqueta:', error)
        this.mensagem = this.extrairMensagemErro(error)
        this.tipoMensagem = 'error'
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>
